import styled from 'styled-components';
import { FlexRow, IconButton, SvgIcon, Text } from '@make-software/tg-mini-app-ui';

export const WalletButton = styled.div<{ isConnected: boolean }>(({ theme, isConnected }) =>
  theme.withMedia({
    display: 'inline-flex',
    height: '24px',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: theme.typography.fontFamily.sans,
    gap: '10px',
    border: `1px solid ${isConnected ? theme.colors.connectedAccent : theme.colors.border}`,
    color: isConnected ? theme.colors.connectedAccent : theme.colors.border,
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${isConnected ? theme.colors.connectedAccent : theme.colors.lightGray}`,
      color: isConnected ? theme.colors.connectedAccent : theme.colors.lightGray
    }
  })
);

export const PageWrapper = styled.div<{ padding?: string }>(({ theme, padding = '0 16px' }) =>
  theme.withMedia({
    padding
  })
);

export const ModalContentWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    color: theme.colors.contentPrimary
  })
);

export const StyledHeader = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    height: '80px',
    borderBottom: `1px solid ${theme.colors.border}`,
    padding: '0 20px'
  })
);

export const IconWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    minWidth: '40px',
    borderRadius: '4px',
    background: theme.colors.elevated
  })
);

export const CloseIconButton = styled(IconButton)<{ borderColor?: string }>(({ theme, borderColor }) => ({
  border: `1px solid ${borderColor ?? theme.colors.border}`
}));
export const StyledContent = styled.div(({ theme }) =>
  theme.withMedia({
    padding: '16px 20px'
  })
);

export const EarnArea = styled.div<{ margin?: string }>(({ theme, margin }) =>
  theme.withMedia({
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: theme.colors.lightGray,
    lineHeight: '16px',
    margin: margin ? margin : '0 0 12px 0',
    span: {
      color: theme.colors.lightGray,
      fontFamily: theme.typography.fontFamily.display,
      fontWeight: '600'
    }
  })
);

export const ModalDescription = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.colors.lightGray,
    fontSize: '14px',
    fontWeight: 400,
    marginBottom: '16px'
  })
);

export const ButtonWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    padding: '0 8px',
    'button:hover span': {
      color: theme.colors.mainWhite
    }
  })
);

export const TitleRow = styled(Text)<{ margin?: string }>(({ theme, margin }) =>
  theme.withMedia({
    display: 'block',
    margin: margin || '24px 0 8px 0',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '140%',
    letterSpacing: '-0.025rem',
    fontFamily: 'Inter'
  })
);

export const StyledTitle = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px'
  })
);

export const SecondaryText = styled(Text)<{ margin?: string }>(({ theme, margin }) =>
  theme.withMedia({
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    color: '#A9AAAD',
    margin,
    fontFamily: 'Inter'
  })
);

export const StyledEarnIcon = styled(SvgIcon)<{ fillColor?: string; disabled?: boolean }>(
  ({ theme, fillColor = '#F1BF0B', disabled }) =>
    theme.withMedia({
      'svg path': {
        fill: fillColor,
        opacity: disabled ? 0.4 : 1
      }
    })
);

export const CommonDescription = styled.span(() => ({
  color: 'var(--Color-Secondary, #A9AAAD)',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '140%',
  marginTop: '12px',
  display: 'block',
  whiteSpace: 'pre-line'
}));

export const NotificationBadge = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    backgroundColor: '#FB6F6A',
    borderRadius: '50%',
    height: '16px',
    width: '16px',
    zIndex: 1,
    color: '#FFF',
    left: '18px',
    top: '-4px'
  })
);

export const StyledTransactionProcessHeader = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    width: '100%'
  })
);

export const LastContentRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    marginBottom: '26px'
  })
);

export const CircleIconWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    width: '30px',
    minWidth: '30px',
    borderRadius: '50%',
    background: 'rgba(187, 190, 223, 0.23)'
  })
);

export const StyledCloseIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer',
    'svg path': {
      fill: 'white'
    }
  })
);
